import { useState, FC } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { Search as SearchIcon } from 'lucide-react';
import { cn } from '@new/lib';

export const HeaderSearch: FC = () => {
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState('');

  const handleSearch = () => {
    if (searchValue.trim()) {
      console.log('search');
      navigate({
        to: '/search',
        search: { searchText: searchValue },
      });
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <div
      className={cn(
        'flex items-center justify-between',
        'w-full max-w-97.25 h-12 px-4',
        'rounded-lg border-[1.5px] border-(--neutral-white-NW800)',
        'bg-(--neutral-white-NW1000)'
      )}
    >
      <input
        type="text"
        placeholder="Search"
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        onKeyDown={handleKeyDown}
        className={cn(
          'flex-1 outline-none border-none bg-transparent',
          'text-sm text-(--neutral-black-NB600)',
          'placeholder:text-(--neutral-black-NB400)'
        )}
      />
      <button
        onClick={handleSearch}
        className={cn(
          'flex items-center justify-center',
          'cursor-pointer outline-none border-none bg-transparent',
          'text-(--neutral-black-NB600) hover:text-(--primary-O1000)',
          'transition-colors duration-200'
        )}
      >
        <SearchIcon size={20} strokeWidth={1.5} className="stroke-(--neutral-white-NW600)" />
      </button>
    </div>
  );
};
